module.exports = __webpack_public_path__ + "c18def7ebeb304bcdf81e474182d0f21.svg";